<template>
  <section class="section">
    <div class="container">
      <h1 class="is-size-2 has-text-centered">Je bent niet (meer) ingelogd</h1>
      <p class="is-size-5 has-text-centered mt-3">
        Je sessie is verlopen of je bent nog niet ingelogd. Log opnieuw in via het inlogveld
        rechtsboven: vul je gebruikersnaam in, klik op Verstuur en voer de OTP code in die je per
        mail ontvangt.
      </p>
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Unauthorized',
})
export default class Unauthorized extends Vue {}
</script>
